export { FluentTheme } from '@fluentui/theme';
